export default __webpack_public_path__ + "static/media/gallery_02.8e403b69.jpg";